import {CLOSE_RIGHT_DRAWER, DISMISS_TOASTER_MESSAGE, SET_TOASTER_MESSAGE, TOGGLE_LEFT_DRAWER, TOGGLE_RIGHT_DRAWER} from "./mutations";
import {version} from '../../../package.json';

const getDefaultState = () => {
    return {
        drawerLeft: null,
        drawerRight: false,
        toasterMessage: {
            state: false,
            value: "",
        },
        version: undefined
    }
};

const state = getDefaultState();

const getters = {
    appVersion() {
        return "Personnel v" + version + "  ";
    },
    toasterMessage(state) {
        return state.toasterMessage;
    },
    drawerLeft(state) {
        return state.drawerLeft;
    },
    drawerRight(state) {
        return state.drawerRight;
    },
};

const actions = {};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_LEFT_DRAWER](state) {
        if (state.drawerLeft == null) {
            state.drawerLeft = false;
        } else {
            state.drawerLeft = !state.drawerLeft;
        }
    },
    [TOGGLE_RIGHT_DRAWER](state) {
        state.drawerRight = !state.drawerRight;
    },
    [CLOSE_RIGHT_DRAWER](state) {
        state.drawerRight = false;
    },
    [SET_TOASTER_MESSAGE](state, data) {
        state.toasterMessage.state = true;
        state.toasterMessage.value = data.value;
    },
    [DISMISS_TOASTER_MESSAGE](state) {
        state.toasterMessage.state = false;
        state.toasterMessage.value = '';
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
